import { PaginationRequest } from "../../objects/pagination";
import { customFetch } from "../../utils/http";

export const getDistributors = async (req: PaginationRequest) => {
  const queryParams = new URLSearchParams();
  queryParams.set("page", String(req.page));
  queryParams.set("size", String(req.size));
  if (req.search) queryParams.set("search", req.search);
  return await customFetch(
    `v1/distributor?${queryParams}`,
    {
      method: "GET",
    }
  );
};

export const createDistributor = async (data: any) => {
  return await customFetch("v1/distributor", {
    method: "POST",
    body: JSON.stringify(data),
  });
};

export const updateDistributor = async (id: string, data: any) => {
  return await customFetch(`v1/distributor/${id}`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
};

export const deleteDistributor = async (id: string) => {
  return await customFetch(`v1/distributor/${id}`, {
    method: "DELETE",
  });
};
